import React from 'react';
import { Box } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { ShowcaseNumber } from './ShowcaseNumber';
import { ShowcaseLogo } from './ShowcaseLogo';

const useStyles = makeStyles((theme) =>
  createStyles({
    Showcase: {
		maxWidth: 1280,
		width: "100%",
		display: 'flex',
		alignItems: 'stretch',
		justifyContent: 'space-between',
		gap: 64,
		opacity: 1,
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		marginLeft: "auto",
		marginRight: "auto",
		boxSizing: "border-box",
		[theme.breakpoints.up('md')]: {
			paddingLeft: theme.spacing(4),
			paddingRight: theme.spacing(4),
		},
		[theme.breakpoints.down(1280)]: {
			flexDirection: "column-reverse",
			alignItems: "center",
			gap: theme.spacing(8),
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(2),
		},
    },
	Stats: {
		flex: 1,
    	display: 'flex',
    	justifyContent: 'center',
    	alignItems: 'center',
	},
	Logos: {
		flex: 1,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	}
  })
);

export const ShowcaseSection: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.Showcase}>
		<Box className={classes.Stats}>
			<ShowcaseNumber />
		</Box>
		<Box className={classes.Logos}>
			<ShowcaseLogo/>
		</Box>
    </Box>
  );
};
